import { actionClient } from '@/api'

export default {

  namespaced: true,

  state: {
    token: localStorage.getItem('token') || null,
    currentUser: JSON.parse(localStorage.getItem('user') || 'null') || null,
    roles: []
  },


  mutations: {

    setToken(state, { token }) {
      state.token = token
      if (token === null) {
        localStorage.removeItem('token')
      } else {
        localStorage.setItem('token', token)
      }
    },

    setCurrentUser(state, { user, roles = [] }) {
      state.currentUser = user
      state.roles = roles
      if (user === null) {
        localStorage.removeItem('user')
      } else {
        localStorage.setItem('user', JSON.stringify(user))
      }
    }

  },

  actions: {

    async login({ commit }, data) {
      const { token } = await actionClient.post('auth', data)
      //const token = '123456'
      commit('setToken', { token })
      const user = await actionClient.get('me')
      console.log(user)
      //const user = { name: '开心测试' }
      commit('setCurrentUser', { user })
    },

    logout({ commit }) {
      commit('setToken', { token: null })
      commit('setCurrentUser', { user: null })
    },

    async update(_, payload) {
      await actionClient.post('me', payload)
    }

  }


}
